import { BaseSchema, ModelType, type ToOneRelationship } from '~~/app/base/schemas/BaseSchema';

type InvoicingPaymentRemindersSettingAttributes = {
    level: number;
    dueDays: number;
    enabled: boolean;
    emailCopy: boolean;
    emailSubject: TranslatedField;
    emailText: TranslatedField;
};

type InvoicingPaymentRemindersSettingMeta = {};
type InvoicingPaymentRemindersSettingRelationships = {
    invoicePaymentReminderGroup: ToOneRelationship<ModelType.INVOICE_PAYMENT_REMINDER_GROUPS>;
};

export default class InvoicingPaymentRemindersSettingSchema extends BaseSchema<
    InvoicingPaymentRemindersSettingAttributes,
    InvoicingPaymentRemindersSettingMeta,
    InvoicingPaymentRemindersSettingRelationships
> {
    protected type: ModelType = ModelType.INVOICING_PAYMENT_REMINDERS_SETTINGS;
}
